import { useUpgradePlanMutationApi } from '@aibees/shared/api';
import { SHARED_ROUTES } from '@aibees/shared/constants';
import {
  ConfirmPlanDialogProps,
  FeedbackPlanDialogProps,
  ResultPlanDialogProps,
  SubscriptionActiveAction,
} from '@aibees/shared/definition';
import { useState } from 'react';
import { usePlanCardContext } from '../../plan-card/context';
import { SubscriptionModalType } from '../types';
import { useSubscriptionModals } from './use-subscription-modals';

export function useDowngradToPaidFlow() {
  const { activeModal, closeModal, openModal } = useSubscriptionModals();
  const { selectedPlan } = usePlanCardContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const immediatelyApi = useUpgradePlanMutationApi(
    SubscriptionActiveAction.IMMEDIATELY
  );

  // ---------------------------------- Handlers --------------------------------
  const handleStart = () => {
    openModal(SubscriptionModalType.CONFIRM_MODAL);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    if (!selectedPlan) return;
    immediatelyApi
      .mutateAsync({
        plan: selectedPlan?.id,
        redirect: {
          success: window.origin + SHARED_ROUTES.priceAndPlanSuccessDowngrade,
          failed: window.origin + SHARED_ROUTES.priceAndPlanSuccessFailure,
        },
      })
      .then((data) => {
        window.location.href = data.url;
      });
  };

  const handleCommentSubmit = async () => {};

  const handleFinalResult = () => {
    closeModal();
  };
  // ---------------------------------- Handlers --------------------------------

  // ---------------------------------- Props --------------------------------
  const confirmDialogProps: ConfirmPlanDialogProps = {
    onConfirm: handleConfirm,
    onCancel: () => {},
  };

  const feedbackDialogProps: FeedbackPlanDialogProps = {
    onConfirm: handleCommentSubmit,
    onCancel: () => {},
  };

  const resultDialogProps: ResultPlanDialogProps = {
    onConfirm: handleFinalResult,
    onCancel: () => {},
  };
  // ---------------------------------- Props --------------------------------

  return {
    activeModal,
    onStart: handleStart,
    closeModal,
    confirmDialogProps,
    feedbackDialogProps,
    resultDialogProps,
  };
}
